import * as React from "react"
import { currencyData, getEmojiByCurrencyCode } from "country-currency-emoji-flags"
import { Check, ChevronsUpDown } from "lucide-react"

import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"

interface CurrencySelectProps {
  value: string | undefined
  onChange: (value: string | undefined) => void
}

export function CurrencySelect({ value, onChange }: CurrencySelectProps) {
  const [open, setOpen] = React.useState(false)

  const currencies = Object.keys(currencyData).map((c: string) => ({
    value: c,
    label: `${c}`,
    emoji: getEmojiByCurrencyCode(c),
  }))
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-12 justify-between border-0 px-1 py-1"
        >
          {value ? (
            <div className="flex items-center">
              <span>{getEmojiByCurrencyCode(value)}</span>
            </div>
          ) : (
            "Select currency"
          )}
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0">
        <Command>
          <CommandList>
            <CommandInput placeholder="Search currency..." />
            <CommandEmpty>No currency found.</CommandEmpty>
            <CommandGroup>
              {currencies.map((currency: { value: string; label: string; emoji: string }) => (
                <CommandItem
                  key={currency.value}
                  value={currency.value}
                  onSelect={(currentValue) => {
                    onChange(currentValue === value ? undefined : currentValue)
                    setOpen(false)
                  }}
                >
                  <Check className={cn("mr-2 h-4 w-4", value === currency.value ? "opacity-100" : "opacity-0")} />
                  <span className="mr-2">{currency.emoji}</span>
                  {currency.label}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
